import { render } from "./UserDrawer.vue?vue&type=template&id=6b839f50&scoped=true"
import script from "./UserDrawer.vue?vue&type=script&lang=js"
export * from "./UserDrawer.vue?vue&type=script&lang=js"

import "./UserDrawer.vue?vue&type=style&index=0&id=6b839f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b839f50"]])

export default __exports__